import { makeStyles } from '@material-ui/core/styles';
import sheetDetailsStyles
  from 'pages/Worklogs/components/SheetForm/components/styles';

export default makeStyles(sheetDetailsStyles);
